import { render, staticRenderFns } from "./form-epi.vue?vue&type=template&id=740bf190&scoped=true&"
import script from "./form-epi.vue?vue&type=script&lang=js&"
export * from "./form-epi.vue?vue&type=script&lang=js&"
import style0 from "./form-epi.vue?vue&type=style&index=0&id=740bf190&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740bf190",
  null
  
)

export default component.exports